import { PureAbility, AbilityBuilder, type AbilityClass } from '@casl/ability';
import type { UserRole } from '@prisma/client';

type User = { role: UserRole };
type CRUDActions = 'manage' | 'create' | 'read' | 'update' | 'delete';
type Abilities =
  | [CRUDActions | 'approve' | 'formalize' | 'reformalize', 'admin.auction']
  | [CRUDActions | 'activate', 'admin.company']
  | [CRUDActions, 'admin.branches']
  | [CRUDActions, 'admin.auction.bids']
  | ['manage', 'all'];

export type AppAbility = PureAbility<Abilities>;
export const AppAbility = PureAbility as AbilityClass<AppAbility>;

type DefinePermissions = (user: User | undefined, builder: AbilityBuilder<AppAbility>) => void;
type Roles = UserRole;

const rolePermissions: Record<Roles, DefinePermissions> = {
  admin(_user, { can }) {
    can('manage', 'all');
  },
  ['admin_manager'](_user, { can }) {
    // companies
    can('read', 'admin.company');
  },
  ['vendor_owner'](_user) {}
};

export function defineAbilityFor(user: User | undefined): AppAbility {
  const builder = new AbilityBuilder(AppAbility);

  if (user) {
    if (typeof rolePermissions[user.role] === 'function') {
      rolePermissions[user.role](user, builder);
    } else {
      throw new Error(`Trying to use unknown role "${user.role}"`);
    }
  }

  return builder.build();
}
